module.exports = __webpack_public_path__ + "static/media/3r_logo.8d642543.png";